<!-- PAGE HEADER -->
<div class="page-header filter-card">
  <div class="page-header-left">
    <div>
      <div class="page-header-title">Announcements</div>
      <div class="page-header-sub">
        Manage promotional and informational announcements
      </div>
    </div>
  </div>

  <div class="page-header-right">
    <!-- <div class="badge-total">
      {{ index === 0 ? totalApprovedDataCount : totalDataCount }} Total Records
    </div> -->
    <button
      nz-button
      nzType="primary"
      [routerLink]="['add']"
      [queryParams]="{ index: index }"
    >
      <i nz-icon nzType="plus"></i> Add New Announcement
    </button>
  </div>
</div>

<!-- TABLE CARD -->
<div class="table-card">
  <nz-tabset
    (nzSelectedIndexChange)="changeIndex($event)"
    [nzSelectedIndex]="index"
  >
    <!-- ══════════ TAB 1: Approved ══════════ -->
    <nz-tab nzTitle="Approved Announcements">
      <nz-table
        #approvedTbl
        [nzData]="allApprovedAnnouncements"
        [nzLoading]="loading"
        [nzTotal]="totalApprovedDataCount"
        [(nzPageSize)]="pageSize"
        [nzPageIndex]="pageIndex"
        [nzFrontPagination]="false"
        nzShowSizeChanger
        (nzQueryParams)="onQueryParamsChange($event)"
      >
        <thead>
          <tr>
            <th nzWidth="70px">Image</th>
            <th>Title</th>
            <th nzWidth="140px">Module</th>
            <th nzWidth="180px">Timeline</th>
            <th nzWidth="100px">Live/Expired</th>
            <th nzWidth="90px">Status</th>
            <th nzWidth="130px">Created By</th>
            <th nzWidth="110px" class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of approvedTbl.data">
            <td>
              <img
                *ngIf="item.image"
                [nzSrc]="mediaBaseUrl + item.image"
                nz-image
                style="
                  width: 44px;
                  height: 44px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
              <div class="notif-thumb-placeholder" *ngIf="!item.image">📢</div>
            </td>
            <td>{{ item.title || "N/A" }}</td>
            <td>
              <nz-tag>{{ getModuleLabel(item.module) }}</nz-tag>
            </td>
            <td>
              <div class="date-primary">
                Start: {{ item.startDate | date: "dd MMM yyyy" }}
              </div>
              <div class="date-secondary">
                End: {{ item.endDate | date: "dd MMM yyyy" }}
              </div>
            </td>
            <td>
              <span
                class="tag"
                [ngClass]="isExpired(item) ? 'tag-red' : 'tag-green'"
              >
                {{ isExpired(item) ? "Expired" : "Live" }}
              </span>
            </td>
            <td>
              <nz-switch
                *ngIf="userRole !== 'subAdmin'"
                [ngModel]="item.status === 'active'"
                (click)="updateStatus(item._id, item.status)"
              ></nz-switch>
              <span
                class="tag"
                *ngIf="userRole === 'subAdmin'"
                [ngClass]="item.status === 'active' ? 'tag-green' : 'tag-red'"
              >
                {{ item.status === "active" ? "Active" : "Inactive" }}
              </span>
            </td>
            <td>
              <div class="user-cell">
                <div class="avatar">{{ (item.createdBy?.name || "A")[0] }}</div>
                <span class="user-name">{{
                  item.createdBy?.name || "Admin"
                }}</span>
              </div>
            </td>
            <td class="action-buttons">
              <a
                nz-button
                nz-tooltip
                nzTooltipTitle="Edit"
                nzTooltipPlacement="topCenter"
                [routerLink]="['update', item._id]"
                [queryParams]="{ index: index }"
              >
                <i nz-icon nzType="form" nzTheme="outline"></i>
              </a>
              <a
                *ngIf="userRole === 'admin'"
                class="action-button delete"
                nz-button
                nzDanger
                nz-tooltip
                nzTooltipTitle="Delete"
                nzTooltipPlacement="topRight"
                (click)="confirmDelete(item._id)"
              >
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-tab>

    <!-- ══════════ TAB 2: Un-approved ══════════ -->
    <nz-tab nzTitle="Un-approved Announcements">
      <nz-table
        #unapprovedTbl
        [nzData]="allAnnouncements"
        [nzLoading]="loading"
        [nzTotal]="totalDataCount"
        [(nzPageSize)]="pageSize"
        [nzPageIndex]="pageIndex"
        [nzFrontPagination]="false"
        nzShowSizeChanger
        (nzQueryParams)="onQueryParamsChange($event)"
      >
        <thead>
          <tr>
            <th nzWidth="70px">Image</th>
            <th>Title</th>
            <th nzWidth="140px">Module</th>
            <th nzWidth="180px">Timeline</th>
            <th nzWidth="100px">Live/Expired</th>
            <th nzWidth="130px">Created By</th>
            <th nzWidth="150px">Rejected Reason</th>
            <th nzWidth="110px">Approve Status</th>
            <th nzWidth="150px" class="text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of unapprovedTbl.data">
            <td>
              <img
                *ngIf="item.image"
                [nzSrc]="mediaBaseUrl + item.image"
                nz-image
                style="
                  width: 44px;
                  height: 44px;
                  object-fit: cover;
                  border-radius: 8px;
                "
              />
              <div class="notif-thumb-placeholder" *ngIf="!item.image">📢</div>
            </td>
            <td>{{ item.title || "N/A" }}</td>
            <td>
              <nz-tag>{{ getModuleLabel(item.module) }}</nz-tag>
            </td>
            <td>
              <div class="date-primary">
                Start: {{ item.startDate | date: "dd MMM yyyy" }}
              </div>
              <div class="date-secondary">
                End: {{ item.endDate | date: "dd MMM yyyy" }}
              </div>
            </td>
            <td>
              <span
                class="tag"
                [ngClass]="isExpired(item) ? 'tag-red' : 'tag-green'"
              >
                {{ isExpired(item) ? "Expired" : "Live" }}
              </span>
            </td>
            <td>
              <div class="user-cell">
                <div class="avatar">{{ (item.createdBy?.name || "A")[0] }}</div>
                <span class="user-name">{{
                  item.createdBy?.name || "Admin"
                }}</span>
              </div>
            </td>
            <td>
              <span *ngIf="item.rejectionReason" class="ellipsis">{{
                item.rejectionReason
              }}</span>
            </td>
            <td>
              <nz-tag
                [nzColor]="
                  item.approveStatus === 'approved'
                    ? 'green'
                    : item.approveStatus === 'pending'
                      ? 'lime'
                      : 'volcano'
                "
              >
                {{ item.approveStatus }}
              </nz-tag>
            </td>
            <td class="action-buttons">
              <a
                nz-button
                nz-tooltip
                nzTooltipTitle="Edit"
                nzTooltipPlacement="topCenter"
                [routerLink]="['update', item._id]"
                [queryParams]="{ index: index }"
              >
                <i nz-icon nzType="form" nzTheme="outline"></i>
              </a>
              <!-- Approve -->
              <a
                *ngIf="userRole !== 'subAdmin'"
                class="action-button top-margin"
                nz-button
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to approve this announcement?"
                (nzOnConfirm)="updateApproveStatus(item._id, 'approved')"
                nz-tooltip
                nzTooltipTitle="Approve"
                nzTooltipPlacement="topRight"
              >
                <i nz-icon nzType="file-done" nzTheme="outline"></i>
              </a>
              <!-- Reject -->
              <a
                *ngIf="
                  userRole !== 'subAdmin' && item.approveStatus !== 'rejected'
                "
                class="action-button top-margin delete"
                nz-button
                nz-popconfirm
                nzPopconfirmTitle="Are you sure you want to reject this announcement?"
                (nzOnConfirm)="openRejectionReason(item._id)"
                nz-tooltip
                nzTooltipTitle="Reject"
                nzTooltipPlacement="topRight"
              >
                <i nz-icon nzType="close-circle" nzTheme="fill"></i>
              </a>
              <!-- Delete -->
              <a
                *ngIf="userRole === 'admin'"
                class="action-button delete"
                nz-button
                nzDanger
                nz-tooltip
                nzTooltipTitle="Delete"
                nzTooltipPlacement="topRight"
                (click)="confirmDelete(item._id)"
              >
                <i nz-icon nzType="delete" nzTheme="outline"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-tab>
  </nz-tabset>
</div>
